import React, { ReactChild, ReactNode } from 'react';
import styles from './boxWrapper.module.css';

interface Props {
  children?: JSX.Element | JSX.Element[] | ReactChild | ReactNode;
}

const BoxWrapper: React.FunctionComponent<Props> = (props) => {
  return <div className={styles.wrapper}>{props.children}</div>;
};

export default BoxWrapper;
